import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "history-expense-modal" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "dropdown-list" }
const _hoisted_4 = { class: "title-item-text" }
const _hoisted_5 = { class: "nested-list" }
const _hoisted_6 = { class: "dropdown-item" }
const _hoisted_7 = { class: "top" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = { class: "more-button" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { class: "category-container" }
const _hoisted_12 = { class: "category" }
const _hoisted_13 = { class: "date-item" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "sure-delete" }
const _hoisted_16 = { class: "modal-actions" }

import axios from "axios";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { API_URL } from "@/api";
import { deleteExpenses } from "@/modules/finances/services/finances.services";
import { ModalTypes } from "@/enums/enums";
import BaseSelect from "@/components/ui/BaseSelect.vue";
import IconMore from "@/icons/IconMore.vue";
import BaseCheckbox from "@/components/ui/BaseCheckbox.vue";
import UIButton from "@/modules/UI-kit/UIButton.vue";

interface ExpensesItems {
  id: number;
  sum: number;
  date: string;
  title: string;
  category_title: string;
  item_title: string;
  checked: boolean;
}

interface ExpensesHistoryItems {
  date: Date;
  expenses: ExpensesItems[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryExpensesModal',
  setup(__props) {

const store = useStore();
const route = useRoute();

const sureDelete = ref(false);

const role = computed(() => store.state.authStore.role);

const isButtonDisabled = computed(() => {
  return !items.value.some((item) =>
    item.expenses.some((expense) => expense.checked)
  );
});

const formatDate = (dateInput: Date | string): string => {
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  return new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

function formatTime(dateString: string): string {
  const date = new Date(dateString);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}

const formatCurrency = (sum: number): string => {
  return new Intl.NumberFormat("ru-RU").format(sum);
};

const items = ref<ExpensesHistoryItems[]>([]);

const onDeleteHandler = async () => {
  const selectedIds: number[] = [];

  items.value.forEach((item) => {
    item.expenses.forEach((expense) => {
      if (expense.checked) {
        selectedIds.push(expense.id);
      }
    });
  });

  const currentSpotId = localStorage.getItem("spotId");
  if (!currentSpotId || selectedIds.length === 0) return;

  try {
    await deleteExpenses(selectedIds, currentSpotId);
    await fetchItems();
    await store.dispatch("financesStore/fetchExpensesSum", {
      role: role.value,
      partnerId: route.params?.id,
      spotId: localStorage.getItem("spotId"),
    });
    sureDelete.value = false;
  } catch (error) {
    console.error("Ошибка при удалении:", error);
  }
};

const fetchItems = async () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return;

  const url =
    role.value === "ROLE_PARTNER"
      ? `${API_URL}/finance/partner/${localStorage.getItem("spotId")}/expenses`
      : `${API_URL}/finance/stuff/expenses/${
          route.params?.id
        }/${localStorage.getItem("spotId")}`;

  try {
    const { data } = await axios.get(url, {
      headers: { Authorization: `Bearer_${token}` },
    });
    items.value = data.expenses.map((item: any) => ({
      ...item,
      expenses: item.expenses.map((expense: any) => ({
        ...expense,
        checked: false,
      })),
    }));
  } catch (error) {
    console.error("Ошибка запроса:", error);
  }
};

const handleEdit = (expense: ExpensesItems) => {
  store.commit("modalsStore/showModal", {
    modalType: ModalTypes.addExpensesModal,
    data: {
      isEdit: true,
      expenseData: expense,
    },
  });
};

onMounted(async () => {
  await fetchItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("h1", { class: "title-text" }, "История расходов")
      ], -1)),
      (items.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "dropdown-item"
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("strong", null, _toDisplayString(formatDate(item.date)), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.expenses, (expense, expenseIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: expense.id || expenseIndex,
                        class: "nested-item"
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("strong", null, _toDisplayString(formatCurrency(expense.sum)) + " руб. - " + _toDisplayString(expense.title), 1),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(BaseCheckbox, {
                                modelValue: expense.checked,
                                "onUpdate:modelValue": ($event: any) => ((expense.checked) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _createVNode(BaseSelect, {
                                options: [{ label: 'Редактировать', value: 'edit' }],
                                "model-value": '',
                                onChange: ($event: any) => (handleEdit(expense))
                              }, {
                                trigger: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(IconMore)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onChange"])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_10, _toDisplayString(expense.item_title), 1),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(expense.category_title), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(formatTime(expense.date)), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[2] || (_cache[2] = [
            _createElementVNode("p", { class: "no-data" }, "Нет данных для отображения.", -1)
          ]))),
      _createVNode(UIButton, {
        "is-disabled": isButtonDisabled.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (sureDelete.value = true)),
        class: "delete-button"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Удалить ")
        ])),
        _: 1
      }, 8, ["is-disabled"])
    ], 512), [
      [_vShow, !sureDelete.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_15, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, [
        _createElementVNode("h1", { class: "title-text" }, "Удаление расходов")
      ], -1)),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "sure-delete-description" }, " Вы уверены, что хотите удалить расход ", -1)),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(UIButton, {
          "is-disabled": isButtonDisabled.value,
          onClick: onDeleteHandler
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" Удалить ")
          ])),
          _: 1
        }, 8, ["is-disabled"]),
        _createVNode(UIButton, {
          "is-disabled": isButtonDisabled.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (sureDelete.value = false)),
          "button-style": "ghost"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Отмена ")
          ])),
          _: 1
        }, 8, ["is-disabled"])
      ])
    ], 512), [
      [_vShow, sureDelete.value]
    ])
  ]))
}
}

})